export default __webpack_public_path__ + "static/media/Spring21_19.58fe0090.png";